import {
    ACTUALIZAR_LIST_TEMPLATES_PRODUCCION,
    AGREGAR_TEMPLATE_PRODUCCION,
    MODIFICAR_TEMPLATE_PRODUCCION,
} from "./templateProduccionActions";

const templateProduccionReducer = (state, action) => {
    switch (action.type) {

        case ACTUALIZAR_LIST_TEMPLATES_PRODUCCION: {
            return {
                ...state,
                templatesProduccionList: action.payload
            }
        };

        case AGREGAR_TEMPLATE_PRODUCCION: {
            return {
                ...state,
                templatesProduccionList: [action.payload, ...state.templatesProduccionList]
            }
        };

        case MODIFICAR_TEMPLATE_PRODUCCION: {
            return {
                ...state,
                templatesProduccionList: state.templatesProduccionList.map((t) => t._id === action.payload._id ? action.payload : t)
            }
        };

        default: return state;
    }
}

export default templateProduccionReducer;
